import { FaJava, FaDocker, FaGitAlt } from "react-icons/fa";
import { GrMysql, GrReactjs } from "react-icons/gr";
import { SiJavascript } from "react-icons/si";
import { SiSpring, SiKubernetes, SiGooglecloud } from "react-icons/si";
import { DiMongodb } from "react-icons/di";

export const skills = [
  { name: "Java", icon: <FaJava /> },
  { name: "Spring Boot", icon: <SiSpring /> },
  { name: "GCP ", icon: <SiGooglecloud /> },
  { name: "MongoDB", icon: <DiMongodb /> },
  { name: "MySQL", icon: <GrMysql /> },
  { name: "Kubernetes", icon: <SiKubernetes /> },
  { name: "Docker", icon: <FaDocker /> },
  { name: "Git", icon: <FaGitAlt /> },
  { name: "React.js", icon: <GrReactjs /> },
  { name: "JavaScript", icon: <SiJavascript /> },
];

export default {
  skills,
};
